import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import ProfileTabContent from "./ProfileTabContent";
import { NitroTabs } from "nitro-components";
import Container from "../layouts/Container";

const PageContainer = styled.section`
  background-color: ${props => props.theme.color.white};
  position: absolute;
  width: 100%;
`;

const ParentContainer = styled.div`
  text-align:center;
`;

const TabsContainer = styled.div`
  justify-content:center;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  padding-top: 15px;
`;

const TabContent = styled.div`
   /*background-color: ${props => props.theme.color.border};*/
   background-color:#f7f7f7;
   padding: 10px 0 10px 0;
`;

const ProfilePage = props => {
  const { tabs, tabValue, handleTabChange, children, fetchingTabs, hideTabs } = props;

  return (
    <PageContainer>
      <Container>
        {fetchingTabs || hideTabs
          ? <div />
          : (
            <TabsContainer>
              <NitroTabs
              lineHeight={32}
              data={tabs}
              active={tabValue}
              underline
              center
              action={handleTabChange}
              stretchHorizontal
            />
          </TabsContainer>
        )}
      </Container>

      <TabContent><Container>{children}</Container></TabContent>
    </PageContainer>
  );
};

ProfilePage.propTypes = {
  // exampleProp: PropTypes.string.isRequired
  tabs: PropTypes.array,
  handleTabChange: PropTypes.func,
  tabValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  hideTabs: PropTypes.bool,
  fetchingTabs: PropTypes.bool
};

ProfilePage.defaultProps = {
  // defaultProp: ''
};

export default ProfilePage;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProfilePage.js